import { createRealGetRequest } from ".";
import { paths } from "../auditTrail.types";

export const realGetAuditTrailData = createRealGetRequest<
  paths["/exp/v1/dna/auditTrail/getAuditTrailData"]
>("auditTrail/getAuditTrailData");
export const realGetSearchedAuditTrailData = createRealGetRequest<
  paths["/exp/v1/dna/auditTrail/getSearchedAuditTrailData"]
>("auditTrail/getSearchedAuditTrailData");
